import React, { useState } from 'react';
import usePersistedState from '../usePersistedState';
import ItemMaster from './ItemMaster';
import SampleTracking from './SampleTracking';
import BaseIngredients from './BaseIngredients';

const TABS = [
  { key: 'items', label: 'Item Master', Comp: ItemMaster },
  { key: 'samples', label: 'Samples', Comp: SampleTracking },
  { key: 'baseingr', label: 'Base Ingredients', Comp: BaseIngredients },
];

export default function MasterData() {
  const [tab, setTab] = usePersistedState('masterdata.tab', 'items');
  const Active = TABS.find(t => t.key === tab).Comp;
  return (
    <div>
      <div className="tabs" style={{ marginBottom: 16 }}>
        {TABS.map(t => (
          <button key={t.key} className={`tab ${tab === t.key ? 'active' : ''}`} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>
      <Active />
    </div>
  );
}
